<template>
  <UModal
    :title="title"
    :description="description"
    :close="{
      onClick: () => emit('close', false),
    }"
    :ui="{
      title: 'typo-heading-h3 text-modal-title max-w-83.5 max-md:mb-2.5',
      header:
        'pr-10! pt-8 pb-0! mb-6 whitespace-normal border-b-0 max-md:p-5 max-md:pr-18! max-md:min-h-auto',
      body: 'typo-paragraph-sm-regular font-lato pt-0! max-md:p-5 text-content-default-secondary',
    }"
  >
    <template #close>
      <UButton
        class="absolute w-8 h-8 top-6 right-6 max-md:top-5 max-md:right-5 text-neutral-default"
        variant="outline"
        icon="i-local-close"
        color="neutral"
        size="sm"
        @click="emit('close', false)"
      />
    </template>

    <template #body>
      <ReviewForm :api-method="apiMethod" />
    </template>
  </UModal>
</template>

<script setup lang="ts">
import ReviewForm from '../forms/ReviewForm.vue'

defineOptions({
  name: 'ReviewModal',
})

const emit = defineEmits<{
  close: [boolean]
}>()

defineProps<{
  title?: string
  description?: string
  apiMethod?: any
}>()
</script>
